import ArticleRelatedRecipes from './articleRelatedRecipes'

const relatedRecipes = new ArticleRelatedRecipes()
relatedRecipes.init()
